import CustomerAccount from "models/account/customer/customerAccount";
import CreateAccount from "models/account/create";
import axiosRequestUtility from "../utilities/AxiosRequestUtility";
import axios from "axios";
import publicAxiosRequestUtility from "utilities/PublicAxiosRequestUtility";

var CancelToken = axios.CancelToken;
var cancel: any;

class AccountService {
  public GetLoggedInProfile(): Promise<CustomerAccount> {
    return axiosRequestUtility.Request({
      method: 'GET',
      url: `GetLoggedInProfile`,
    })
      .then(response => {
        return response.data as CustomerAccount
      })
      .catch(error => {
        console.log(error);
        alert('Error loading account profile. Please try again.')
        return {} as CustomerAccount;
      })
  }

  public UpdateCustomerAccount(customerAccount: CustomerAccount): Promise<boolean> {
    return axiosRequestUtility.Request({
      method: 'PUT',
      url: 'UpdateAccount',
      data: customerAccount
    })
      .then(response => {
        // As of now, the result is just an OK status
        return true;
      })
      .catch(error => {
        console.log(error);
        alert('Error updating account. Please try again.')
        return false;
      })
  }

  public LookupCustomerAccounts(searchText: string): Promise<CustomerAccount[]> {
    if (cancel != undefined) {
      cancel();
    }

    return axiosRequestUtility.Request({
      method: 'GET',
      url: `LookupCustomerAccounts`,
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
      params: {
        'query': searchText
      }
    })
      .then(response => {
        return response?.data ?? []; // Cancelled requests return undefined
      })
      .catch(error => {
        if (!axios.isCancel(error)) {
          console.log(error);
          alert('Error searching customer account information. Please try again.')
          return [];
        }
      })
  }

  public CreateAccount(account: CreateAccount): Promise<boolean> {
    return publicAxiosRequestUtility.Request({
      method: 'POST',
      url: 'CreateAccount',
      data: {
        firstName: account.firstName,
        lastName: account.lastName,
        suffix: account.suffix || null,
        businessName: account.businessName || null,
        dateOfBirth: account.dateOfBirth,
        streetAddress: account.streetAddress,
        streetAddress2: account.streetAddress2 || null,
        city: account.city,
        state: account.state,
        zipCode: account.zipCode,
        phoneNumber: parseInt((account.phoneNumber ?? '').replace(/\D/g, ''), 10),
        farmingStartYear: account.farmingStartYear,
        emailAddress: account.emailAddress,
        password: account.password,
      }
    }).then(r => r.status === 200 || r.status === 201);
  }

  public CheckIfAccountExists(email: string): Promise<boolean> {
    return publicAxiosRequestUtility.Request({
      method: 'GET',
      url: `CheckCustomerAccountExists`,
      params: {
        'email': email
      }
    })
      .then(response => {
        return response?.data ?? true;
      })
      .catch(error => {
        console.log(error);
        alert('Error checking if account exists. Please try again.')
        return true;
      })
  }
}

const accountService = new AccountService();
export default accountService;